import { render } from "./finalizaCompra.vue?vue&type=template&id=d83908ac"
import script from "./finalizaCompra.vue?vue&type=script&lang=js"
export * from "./finalizaCompra.vue?vue&type=script&lang=js"

import "./finalizaCompra.vue?vue&type=style&index=0&id=d83908ac&lang=css"

import exportComponent from "C:\\Projetos_Somasys\\Delivery\\DeliverySoma-SOLO.2023.10.27\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__